import { jsxs, jsx } from "react/jsx-runtime";
const IconArrowLeftSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M14.167 9.167H7.842l2.75-2.742a.837.837 0 0 0-1.184-1.183L5.242 9.408a.833.833 0 0 0-.175.275.833.833 0 0 0 0 .634c.04.102.099.195.175.275l4.166 4.166a.833.833 0 0 0 1.184 0 .832.832 0 0 0 0-1.183l-2.75-2.742h6.325a.833.833 0 0 0 0-1.666Z" })
    ]
  }
);
export {
  IconArrowLeftSvg
};
